import React, {cloneElement, Component} from 'react'
import propTypes from 'prop-types'
import {isEmpty} from 'lodash'

const inputStyle = {display: 'none'}

class FileSelect extends Component {

  fileSelected = () => {
    const {onSelect} = this.props

    const fileList = this.input.files
    if (!isEmpty(fileList)) {
      const files = Array.from(fileList)
      this.input.value = ''
      onSelect(files)
    }
  }

  open = () => {
    this.input.click()
  }

  render() {
    const {multiple} = this.props
    let {children} = this.props

    if (children) {
      children = cloneElement(children, {onClick: this.open})
    }

    return (
      <div className="file-select-container">
        <input
          ref={e => {
            this.input = e
          }}
          type="file"
          name="files"
          title="Upload Files"
          onChange={this.fileSelected}
          style={inputStyle}
          multiple={multiple}
        />
        {children}
      </div>
    )
  }
}

FileSelect.propTypes = {
  onSelect: propTypes.func.isRequired,
  children: propTypes.any,
  multiple: propTypes.bool,
}

FileSelect.defaultProps = {
  multiple: false,
}

export default FileSelect
